import { StyleSheet } from '../page-helpers/aphrodite-export';
import MobileStylesObj from './contactus/mobile';
import DesktopStylesObj from './contactus/desktop';

const MobileStyles = StyleSheet.create(MobileStylesObj);
const DesktopStyles = StyleSheet.create(DesktopStylesObj);

export {
    MobileStyles,
    DesktopStyles
}